import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalBudgetsService } from "services/ClientPortalBudgetsService";
import { ClientPortalBudgetHeadersModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  BudgetHeaders: new ClientPortalBudgetHeadersModel(),
  Loading: false,
};

export const ClientBudgetHeadersTableSlice = createSlice({
  name: "ClientBudgetHeadersTable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBudgetHeadersForClientsBudget.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getBudgetHeadersForClientsBudget.fulfilled, (state, action) => {
        state.BudgetHeaders = action.payload;
        state.Loading = false;
      })
      .addCase(getBudgetHeadersForClientsBudget.rejected, (state) => {
        state.BudgetHeaders = new ClientPortalBudgetHeadersModel();
        state.Loading = false;
      });
  },
});

export const getBudgetHeadersForClientsBudget = createAsyncThunk<
  ClientPortalBudgetHeadersModel,
  { clientID: string; budgetID: string }
>("ClientBudgetHeadersTable/getBudgetHeadersForClientsBudget", async ({ clientID, budgetID }) => {
  const budgetsService = container.get<IClientPortalBudgetsService>(SERVICE_TYPES.ClientPortalBudgetsService);
  return await budgetsService.getBudgetHeadingsForClientsBudget(clientID, parseInt(budgetID));
});

export const selectBudgetHeaders = (state: RootState) => {
  return state.clientBudgetHeadersTable.BudgetHeaders;
};

export const selectLoadingBudgetHeaders = (state: RootState) => {
  return state.clientBudgetHeadersTable.Loading;
};

export default ClientBudgetHeadersTableSlice.reducer;
